export default "__VITE_ASSET__CAaR6Jkl__"